







import { Component, Vue } from 'vue-property-decorator';
import DatePickers from '@/views/components/DatePickers.vue';

@Component({
  components: {
    DatePickers,
  },
})
export default class Home extends Vue {
}
